export default __webpack_public_path__ + "static/button-label-do-dark-e9793353feb548009101fe4f838bc3c1.png";